import React from 'react'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import ContactPhoneOutlinedIcon from '@mui/icons-material/ContactPhoneOutlined';
import BalanceOutlinedIcon from '@mui/icons-material/BalanceOutlined';
import "./navbarmobile.css"
import { motion } from "framer-motion"
import { NavLink } from 'react-router-dom';
import { Close, Menu } from '@mui/icons-material';
const Navbarmobile = () => {
    const [active, setActive] = React.useState(false)

  return (
    <div className="navbarmobile">
        <div className="navbarmobile-wrapper">
            <motion.div className={active ? "navbarmobile-top top-active" : "navbarmobile-top"} onClick={()=>setActive(!active)}
                initial={{x: "-100vw"}}
                animate={{x: 0}}
                transition={{type: "spring", duration: 1, delay: 1.2}}
            >   
                {active ? <Close className="menu-icon"/>
                    : <Menu className="menu-icon"/>
                }
            </motion.div>
            <div className={ active ? "navbarmobile-bottom bottom-active" : "navbarmobile-bottom"}>
                <section className="nav-mobile">
                    <NavLink to="/profile" className={({ isActive })=> isActive ? "active": ""}>
                        <div className="nav-item">
                        <AccountCircleOutlinedIcon className="nav-icon"/> 
                                <div className="toast">
                                    <span>profile page</span>
                                </div>
                        </div>
                    </NavLink>
                    <NavLink to="/skills" className={({ isActive })=> isActive ? "active": ""}>
                        <div className="nav-item">
                            <BalanceOutlinedIcon className="nav-icon"/> 
                            <div className="toast">
                            <span>skills page</span>
                            </div>
                        </div>
                    </NavLink>
                    <NavLink to="/projects" className={({ isActive })=> isActive ? "active": ""}>
                        <div className="nav-item">
                            <AssignmentOutlinedIcon className="nav-icon"/> 
                            <div className="toast">
                            <span>projects page</span>
                            </div>
                        </div>
                    </NavLink>
                    <NavLink to="/contact" className={({ isActive })=> isActive ? "active": ""}>
                        <div className="nav-item">
                            <ContactPhoneOutlinedIcon className="nav-icon"/> 
                            <div className="toast">
                            <span>contact page</span>
                            </div>
                        </div>
                    </NavLink>
                </section>
            </div>
        </div>
    </div>
  )
}

export default Navbarmobile